/**
 * Payment actions
 */
export enum PaymentActionEnum {
	/**
	 * Cancel payment
	 */
	CANCEL = 'cancel',

	/**
	 * Retry payment
	 */
	RETRY = 'retry',

	/**
	 * Complete payment
	 */
	COMPLETE = 'complete',
}
